import { TESSearchField, TESSearchFields } from '../definitions';
import { defaultParkinsonSearchValues, parkinsonExtendedSearchFields } from './parkinson';
import { smaExtendedSearchFields } from './sma';
import { dmdExtendedSearchFields } from './dmd';
import { defaultMsSearchValues, msExtendedSearchFields } from './ms';
import { huntingtonExtendedSearchFields } from './huntington';
import { defaultEpilepsySearchValues, epilepsyExtendedSearchFields } from './epilepsy';
import { defaultSleepApneaSearchValues, sleepApneaExtendedSearchFields } from './sleepApnea';
import { ninmtExtendedSearchFields } from './ninmt';
import { defaultMgravisSearchValues, mgravisExtendedSearchFields } from './mgravis';
import { IExtendedSearch } from '..';
import { defaultCommonSearchValues } from './common';

/**
 * Extended search field specifications
 */
export const extendedSearchFields = (searchFields?: TESSearchFields): { [platform: string]: TESSearchField[] } => ({
  parkinson: parkinsonExtendedSearchFields(),
  sma: smaExtendedSearchFields(),
  dmd: dmdExtendedSearchFields(),
  ms: msExtendedSearchFields(searchFields),
  huntington: huntingtonExtendedSearchFields(),
  epilepsy: epilepsyExtendedSearchFields(),
  sleepApnea: sleepApneaExtendedSearchFields(searchFields),
  ninmt: ninmtExtendedSearchFields(),
  mgravis: mgravisExtendedSearchFields(),
});

export const defaultSearchValues: IExtendedSearch['searchFields'] = {
  ...defaultCommonSearchValues,
  ...defaultMsSearchValues,
  ...defaultParkinsonSearchValues,
  ...defaultSleepApneaSearchValues,
  ...defaultMgravisSearchValues,
  ...defaultEpilepsySearchValues,
};

export const defaultLogicalOperators: IExtendedSearch['logicalOperators'] = {
  examinations: 'OR',
  serologicalProfile: 'OR',
};
